import { jsx as _jsx } from "react/jsx-runtime";
export const Card = ({ children, className = "", padding = "md", onClick }) => {
    const paddingClasses = {
        none: "",
        sm: "p-3",
        md: "p-4",
        lg: "p-6",
    };
    const classes = `card ${paddingClasses[padding]} ${className}`;
    return (_jsx("div", { className: classes, onClick: onClick, role: onClick ? "button" : undefined, tabIndex: onClick ? 0 : undefined, onKeyDown: onClick
            ? (e) => {
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    onClick();
                }
            }
            : undefined, children: children }));
};
